import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

import Typography from '@material-ui/core/Typography'
import Hero from '../components/Hero/Hero'
import BenefitsSection from '../sections/Benefits/BenefitsSection'
import EarningsSection from '../sections/EarningsCalculator/EarningsSection'
import OurCausesSection from '../sections/OurCauses/OurCausesSection'
import HelpSection from '../sections/HelpSection'
import Footer from '../components/Footer'

const PureHomeTemplate = ({
  chartLevelsData,
  chartInfoData,
  onlineChartInfoData,
  FAQData,
  HeroProps,
  intl,
  productsData,
  catalogData,
  productsImage,
  socialLinks,
  phoneLinks,
  helpLinks,
  benefitsData,
  langKey,
  ctaOnClick,
  isEloThemeActive,
  isChartNoProductActive
}) => {
  return (
    <article>
      <Typography component="h1" variant="srOnly">
        <FormattedMessage id="homePageTitle" />
      </Typography>
      <Hero
        data-gtm-category="landing_hero"
        data-gtm-main-action="view"
        data-gtm-label="bloco_hero"
        data-gtm-position="bloco_hero_pos1"
        data-gtm-category-ga4="landing_hero"
        data-gtm-main-action-ga4="view"
        data-gtm-label-ga4="block_hero"
        data-gtm-position-ga4="1"
        isEloThemeActive={isEloThemeActive}
        ctaOnClick={ctaOnClick}
        {...HeroProps}
      />
      <BenefitsSection
        id={intl.formatMessage({ id: 'benefitsSectionId' })}
        data-gtm-category="landing_beneficios"
        data-gtm-main-action="view"
        data-gtm-label="bloco_vantagens"
        data-gtm-position="bloco_vantangens_pos2"
        data-gtm-category-ga4="landing_benefits"
        data-gtm-main-action-ga4="view"
        data-gtm-label-ga4="block_benefits"
        data-gtm-position-ga4="2"
        benefitsData={benefitsData}
        ctaOnClick={ctaOnClick}
        isEloThemeActive={isEloThemeActive}
      />
      <EarningsSection
        id={intl.formatMessage({ id: 'earningsSectionId' })}
        productsData={productsData}
        catalogData={catalogData}
        productsImage={productsImage}
        chartLevelsData={chartLevelsData}
        chartInfoData={chartInfoData}
        onlineChartInfoData={onlineChartInfoData}
        langKey={langKey}
        data-gtm-category="landing_ganhos_como_consultora"
        data-gtm-main-action="view"
        data-gtm-label="bloco_ganhos_como_consultora"
        data-gtm-position="bloco_ganhos_como_consultora_pos3"
        data-gtm-category-ga4="landing_earnings"
        data-gtm-main-action-ga4="view"
        data-gtm-label-ga4="block_earnings"
        data-gtm-position-ga4="3"
        isEloThemeActive={isEloThemeActive}
        isChartNoProductActive={isChartNoProductActive}
        
      />
      <OurCausesSection
        id={intl.formatMessage({ id: 'ourCausesSectionId' })}
        data-gtm-category="landing_nossas_causas"
        data-gtm-main-action="view"
        data-gtm-label="bloco_nossas_causas"
        data-gtm-position="bloco_nossas_causas_pos4"
        data-gtm-category-ga4="landing_our_causes"
        data-gtm-main-action-ga4="view"
        data-gtm-label-ga4="block_our_causes"
        data-gtm-position-ga4="4"
        langKey={langKey}
        ctaOnClick={ctaOnClick}
        isEloThemeActive={isEloThemeActive}
      />
      <HelpSection
        id={intl.formatMessage({ id: 'helpSectionId' })}
        data={FAQData}
        data-gtm-category="landing_ajuda"
        data-gtm-main-action="view"
        data-gtm-label="bloco_ajuda"
        data-gtm-position="bloco_ajuda_pos5"
        data-gtm-category-ga4="landing_faq"
        data-gtm-main-action-ga4="view"
        data-gtm-label-ga4="block_faq"
        data-gtm-position-ga4="5"
        isEloThemeActive={isEloThemeActive}
      />
      <Footer
        socialLinks={socialLinks}
        phoneLinks={phoneLinks}
        helpLinks={helpLinks}
        isEloThemeActive={isEloThemeActive}
      />
    </article>
  )
}

const HomeTemplate = injectIntl(PureHomeTemplate)

export default HomeTemplate
